import React from "react";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { fetchAllChannels } from "../../queries/bank/channelsQuery";
import { fetchAllActiveBanks } from "../../queries/bank/activeBanksQuery";
import { fetchAccountType } from "../../queries/bank/accountTypesQuery";
import api from "../../utils/api";
class NewAccount extends React.Component {
  state = {
    error: {},
    name: "",
    email: "",
    phoneNumber: "",
    isSubmitting: false,
    channels: [],
    status: {
      label: "Active",
      value: true,
    },
    activeBanks: [],
    accountName: "",
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    await this.setState({ user });

    await this.getChannels(true);
    await this.getAccountTypes(true);

    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  };

  getChannels = async (isLoadingChannels) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingChannels });

      const channels = await fetchAllChannels(defaultLanguage, {
        listType: "dropdown",
      });

      this.setState({
        channels,
        isLoadingChannels: false,
      });
    } catch (error) {
      this.setState({ isLoadingChannels: false });
    }
  };

  getActiveBanks = async (isLoadingBanks, bankingChannelId) => {
    const { defaultLanguage } = this.props;
    const { user } = this.state;
    try {
      this.setState({ isLoadingBanks });

      const activeBanks = await fetchAllActiveBanks(defaultLanguage, {
        listType: "dropdown",
        bankingChannelId,
        countryId: user.countryId,
      });

      this.setState({
        activeBanks,
        isLoadingBanks: false,
      });
    } catch (error) {
      this.setState({ isLoadingBanks: false });
    }
  };

  getAccountTypes = async (isLoadingAccountType) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingAccountType });

      const accountTypes = await fetchAccountType(defaultLanguage, {
        listType: "dropdown",
      });

      this.setState({
        accountTypes,
        isLoadingAccountType: false,
      });
    } catch (error) {
      this.setState({ isLoadingAccountType: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });

    if (field === "channel") {
      this.getActiveBanks(true, e.value);
    }
  }

  validateForm() {
    let { error, channel, accountNumber, activeBank, accountName } = this.state;

    if (!channel) {
      error.channel = language[this.props.defaultLanguage].channel_required;
    }

    if (!activeBank) {
      error.activeBank = language[this.props.defaultLanguage].bank_required;
    }

    if (accountNumber === "") {
      error.accountNumber =
        language[this.props.defaultLanguage].account_number_required;
    }

    if (accountName === "") {
      error.accountName =
        language[this.props.defaultLanguage].account_name_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, activeBank, accountNumber, status, accountType, accountName } =
      this.state;
    const { id } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("core")}/account`,
        data: {
          channelId: activeBank.channelId,
          active: status.value,
          accountNumber,
          accountName,
          accountTypeId: accountType.value,
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "account_update_success"
                : "account_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "error",
            language[this.props.defaultLanguage][
              id && id !== "" ? "account_update_error" : "account_added_error"
            ]
          );
        });
    }
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Select
            options={this.state.channels}
            label={language[this.props.defaultLanguage].channel}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.channel}
            onChange={(e) => this.onChangeInput("channel", e)}
            error={this.state.error.channel}
            isLoading={this.state.isLoadingChannels}
          />
          <Select
            options={this.state.activeBanks}
            label={language[this.props.defaultLanguage].bank}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.activeBank}
            onChange={(e) => this.onChangeInput("activeBank", e)}
            error={this.state.error.activeBank}
            isLoading={this.state.isLoadingBanks}
          />
          <Select
            options={this.state.accountTypes}
            label={language[this.props.defaultLanguage].account_type}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.accountType}
            onChange={(e) => this.onChangeInput("accountType", e)}
            error={this.state.error.accountType}
            isLoading={this.state.isLoadingAccountType}
          />
          <Input
            label={language[this.props.defaultLanguage].account_name}
            placeholder={
              language[this.props.defaultLanguage].account_name_placeholder
            }
            value={this.state.accountName}
            onChange={(e) => this.onChangeInput("accountName", e)}
            error={this.state.error.accountName}
          />
          <Input
            label={language[this.props.defaultLanguage].account_number}
            placeholder={
              language[this.props.defaultLanguage].account_number_placeholder
            }
            value={this.state.accountNumber}
            onChange={(e) => this.onChangeInput("accountNumber", e)}
            error={this.state.error.accountNumber}
          />
          <Select
            options={[
              { label: "Active", value: "true" },
              { label: "Inactive", value: "false" },
            ]}
            label={language[this.props.defaultLanguage].status}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.status}
            onChange={(e) => this.onChangeInput("status", e)}
            error={this.state.error.status}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewAccount);
